import type { CSSProperties } from 'react';
const paths = {
  spark: <path d="m12 2 2.8 7.2L22 12l-7.2 2.8L12 22l-2.8-7.2L2 12l7.2-2.8Z" />,
  arrow: <path d="M4 12h16m-6-6 6 6-6 6" />,
  play: <path d="m8 4 12 8-12 8Z" />,
  pause: (
    <>
      <path d="M8 5v14M16 5v14" />
    </>
  ),
  replay: (
    <>
      <path d="M4 9a8 8 0 1 1-1 7M4 3v6h6" />
    </>
  ),
  check: <path d="m5 12 4 4L20 5" />,
  undo: <path d="m9 4-5 5 5 5M4 9h10a6 6 0 0 1 0 12" />,
  sound: (
    <>
      <path d="m10 5-5 4H2v6h3l5 4Z" />
      <path d="M15 8a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14" />
    </>
  ),
  mic: (
    <>
      <rect x="9" y="2" width="6" height="13" rx="3" />
      <path d="M5 10v2a7 7 0 0 0 14 0v-2M12 19v3m-4 0h8" />
    </>
  ),
  stop: <rect x="5" y="5" width="14" height="14" rx="2" />,
  book: (
    <>
      <path d="M12 5C8 2 3 3 3 3v16s5-1 9 2c4-3 9-2 9-2V3s-5-1-9 2v16" />
    </>
  ),
  close: <path d="m6 6 12 12M6 18 18 6" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 6v6l4 2" />
    </>
  ),
  leaf: (
    <>
      <path d="M20 3C6 2 1 12 7 17s15-1 13-14ZM5 21 16 9" />
    </>
  ),
  route: (
    <>
      <circle cx="5" cy="6" r="2" />
      <circle cx="19" cy="18" r="2" />
      <path d="M7 6h8a4 4 0 0 1 0 8H9a4 4 0 0 0 0 8" />
    </>
  ),
  settings: (
    <>
      <path d="M4 7h16M4 17h16" />
      <circle cx="9" cy="7" r="3" />
      <circle cx="15" cy="17" r="3" />
    </>
  ),
  cloud: (
    <>
      <path d="M6 17a5 5 0 1 1 1-10 6 6 0 0 1 11 1 4 4 0 0 1 0 9Z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
};
export type IconName = keyof typeof paths;
export function Icon({
  name,
  className,
  style,
}: {
  name: IconName;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      className={`icon ${className || ''}`}
      style={style}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[name]}
    </svg>
  );
}
